export const linearGradient = (value: string) => ({
  backgroundImage: `linear-gradient(${value})`,
});
